<script setup lang="ts">
import { ref } from "vue";

const contentRef = ref<HTMLElement>();

const scrollToTop = () => {
  if (!contentRef.value) {
    return;
  }

  contentRef.value.scrollTo({ top: 0 });
};

defineExpose({ scrollToTop });
</script>

<template>
  <div class="scroll-box" ref="contentRef">
    <slot></slot>
  </div>
</template>
